export default __webpack_public_path__ + "static/media/case1-logo.01b09a8f.webp";